export default __webpack_public_path__ + "static/media/chansey.b5d6d2d9.gif";